// Map notification type → Vue route object
// Mỗi handler nhận extra (object đã parse) và entityRefId

const COMMENT_MODULE_ROUTE = {
    'purchase-request': (entityRefId, extra) => ({
        name: 'detail-purchase-request',
        query: { id: entityRefId },
        hash: extra?.commentId ? `#comment-${extra.commentId}` : '',
    }),
    approval: (entityRefId, extra) => ({
        name: 'info-approval',
        query: { id: entityRefId },
        hash: extra?.commentId ? `#comment-${extra.commentId}` : '',
    }),
};

export const notificationRedirectMap = {
    'purchase-request': (entityRefId) => ({
        name: 'detail-purchase-request',
        query: { id: entityRefId },
    }),
    'budget-line-request': (entityRefId) => ({
        name: 'detail-budget-line-request',
        query: { id: entityRefId },
    }),
    'budget-line': (entityRefId) => ({
        name: 'detail-budget-line',
        query: { id: entityRefId },
    }),
    comment: (entityRefId, extra) => {
        const module = extra?.module;
        const builder = COMMENT_MODULE_ROUTE[module];
        return builder ? builder(entityRefId, extra) : null;
    },
};

export const resolveNotificationRoute = (notification) => {
    const { notificationEvent } = notification;
    if (!notificationEvent) return null;

    const handler = notificationRedirectMap[notificationEvent.type];
    if (!handler) return null;

    const extra = notificationEvent.extra || null;
    return handler(notificationEvent.entityRefId, extra);
};
